import { toZonedTime } from 'date-fns-tz';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * A small helper function that returns a date with the provided UTC offset.
 */
export function getDateWithOffset(date: Date, utcOffsetHours: number): Date {
  const gmtTimezone = getGmtTimezone(utcOffsetHours);

  return toZonedTime(date, gmtTimezone);
}

/**
 * A small helper function that returns a string representing
 * the GMT timezone in IANA format.
 *
 * In IANA timezone identifiers (used by `date-fns-tz`), "Etc/GMT+4" actually
 * represents UTC-4 (not UTC+4).
 *
 * In the "Etc/GMT±X" format:
 * - "+X" actually means X hours behind UTC (so UTC minus X).
 * - "-X" would mean X hours ahead of UTC (so UTC plus X).
 *
 * So:
 * - "Etc/GMT+4" === UTC-4 (4 hours behind UTC)
 * - "Etc/GMT-4" === UTC+4 (4 hours ahead of UTC)
 *
 */
function getGmtTimezone(utcOffsetHours: number) {
  const gmtOffsetHours = utcOffsetHours * -1;
  const gmtSymbol = gmtOffsetHours > 0 ? '+' : '';

  return `${GMT_TIMEZONE_BASE}${gmtSymbol}${gmtOffsetHours}`;
}

// ─── Constants ───────────────────────────────────────────────────────────────

const GMT_TIMEZONE_BASE = 'Etc/GMT';
